module.exports = __webpack_public_path__ + "img/s9-bg.668df205.jpg";